function TextInvitationToConnect(){
    return (
        <div>Get started by connecting your wallet </div>
    )
}

export default TextInvitationToConnect